import { Box, Divider, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/Buttons/BackButton';
import UserFormSteps from '../components/FormContainers/CreateUserForm/UserFormSteps';
import { eliminateOjectNotTruthyValues } from '../lib/helperFuncs';
import { createUserInitialValues } from '../lib/static/users/initialValues';
import HttpService from '../services/HttpService';
import Theme from '../Themes/main.theme';
import { useState } from 'react';

export interface IUserForm{
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  administrative_unit_id: number | null;
  is_enabled: boolean;
  id?: number;
  afm?: string;
  roles?: { key: string, value: string }[]
}

const CreateUser = () => {
  
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const submitValues = async (values: IUserForm) => {
    setIsLoading(true);
    try {
      const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/users`, 
        eliminateOjectNotTruthyValues(values)
      );
      if (response.status === 201){
        navigate('/admin/users/dashboard');
        enqueueSnackbar(`${t('Επιτυχής Δημιουργία του Χρήστη: ')} ${response.data.last_name} ${response.data.first_name}`, { variant: 'success' });
      }
    } catch (error: any) {
      console.error(error);
      enqueueSnackbar(error.response.data.message, { variant: 'error' });
    }
    setIsLoading(false);
  };

  return (
    <>
      <Box mt={2} mb={2}>
        <BackButton onClick={() => navigate('/admin/users/dashboard')}/>
      </Box>
      <Typography sx={{my: 2}} variant='h2'
        color={Theme?.labelColor?.main}>{t('Δημιουργία Χρήστη')}</Typography>
      <Divider sx={{mb: 5, border: 1, color: Theme?.dividerColor?.main}}/>
      <UserFormSteps
        isLoading={isLoading}
        initialValues={createUserInitialValues}
        onSubmit={submitValues}/>
    </>
  );
};

export default CreateUser;